import Orders from "../views/orders/Index";
import VendorPage from "../views/vendors/Page";
import Received from "../views/orders/Received";
import Request from "../views/orders/Request";
import { default as VendorsMap } from "../views/vendors/Map";
import { default as MyAccount } from "../views/users/Account";
import { default as BecomeVendor } from "../views/users/BecomeVendor";

const client = [
  {
    path: "",
    component: VendorsMap,
    meta: {
      auth: true,
    },
  },
  {
    path: "/account",
    name: "myAccount",
    component: MyAccount,
    meta: {
      auth: true,
    },
  },
  {
    path: "/become-vendor",
    name: "becomeVendor",
    component: BecomeVendor,

    meta: {
      auth: true,
    },
  },
  {
    path: "/orders",
    component: Orders,
    children: [
      {
        path: "",
        name: "sentReferrals",
        component: Request,
      },
      {
        path: "/received-referrals",
        name: "receivedReferrals",
        component: Received,
        meta: {
          noClients: true,
        },
      },
    ],
    meta: {
      auth: true,
    },
  },
  {
    path: "/vendors/:id/order",
    component: VendorPage,
    meta: {
      auth: true,
    },
  },
  {
    path: "/vendors/search",
    component: VendorsMap,
    meta: {
      auth: true,
    },
  },
];

export default client;
